import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { DEFAULT_FILTERS } from '../../constants/filters';
import type { TFilters } from '../../types/filters';

export type IState = { filters: TFilters };

const filtersSlice = createSlice({
  name: 'filters',
  initialState: { filters: DEFAULT_FILTERS },
  reducers: {
    setFilters: (state, { payload }: PayloadAction<TFilters>) => {
      state.filters = payload;
    },
  },
});

const { actions, reducer } = filtersSlice;

export const { setFilters } = actions;

export default reducer;
